import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      const to = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(to);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-[100vh] grid grid-cols-1 lg:grid-cols-2 bg-[#F5EFE4]">
      <div className="relative hidden lg:block">
        <img src="https://images.unsplash.com/photo-1522255272218-7ac5249be344?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="Luxor" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1815] via-[#1A1815]/40 to-transparent" />
        <div className="absolute bottom-0 p-12">
          <p className="overline">Client portal</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 max-w-md leading-tight text-[#F5EFE4]">Return to the house.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16 pt-32 lg:pt-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <p className="overline">Sign in</p>
          <h1 className="font-serif text-5xl mt-4 text-[#1A1815]">Welcome back.</h1>
          <p className="text-[#6B665E] mt-2 text-sm">Use the credentials from your reservation.</p>
          <div className="mt-8 space-y-5">
            <div><label className="luxor-label">Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="luxor-field" data-testid="login-email" /></div>
            <div><label className="luxor-label">Password</label><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="luxor-field" data-testid="login-password" /></div>
          </div>
          <button disabled={loading} data-testid="login-submit" className="luxor-btn-primary w-full mt-8 justify-center disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-[#6B665E] mt-6">
            Not a client yet? <Link to="/register" className="text-[#C5A059] hover:underline" data-testid="login-to-register">Request access</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
